// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K4zw","col":"styles_col__1bh1-"};